"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* globals __RINCA_CONFIG__: true */
exports.appConfig = __RINCA_CONFIG__;



//////////////////
// WEBPACK FOOTER
// ./scripts/appConfig.ts
// module id = 485
// module chunks = 0